module.exports = __webpack_public_path__ + "img/ETLogoWhite.2dd8bd99.png";